import { GET_ADHESION_STATUS, GET_ADHESION_STATUS_SUCCESS, GET_CAMPAGNE_ATTIVE_SCREENING, GET_CAMPAGNE_ATTIVE_SCREENING_SUCCESS, GET_INVITE_REMINDER, GET_INVITE_REMINDER_SUCCESS, GET_PROFILO_ARIANNA, GET_PROFILO_ARIANNA_SUCCESS, GET_SCREENING_RESULT, GET_SCREENING_RESULT_SUCCESS, PATCH_PROFILO_ARIANNA, POST_APPOINTMENT_CANCEL, POST_APPOINTMENT_CONFIRM, POST_APPOINTMENT_CONFIRM_SUCCESS, RESET_SCREENING_STATE } from "./actionsType"


export const getProfiloAriannaAction = () => ({
    type: GET_PROFILO_ARIANNA
})

export const getProfiloAriannaActionSuccess = (payload) => ({
    type: GET_PROFILO_ARIANNA_SUCCESS,
    payload
})
export const patchProfiloAriannaAction = (body) => ({
    type: PATCH_PROFILO_ARIANNA,
    body
})

export const getScreeningResultAction = (body) => ({
    type: GET_SCREENING_RESULT,
    body
})

export const getScreeningResultActionSuccess = (payload) => ({
    type: GET_SCREENING_RESULT_SUCCESS,
    payload
})

export const getAdhesionStatusAction = () => ({
    type: GET_ADHESION_STATUS,
})

export const getAdhesionStatusActionSuccess = (payload) => ({
    type: GET_ADHESION_STATUS_SUCCESS,
    payload
})

export const getInviteReminderAction = () => ({
    type: GET_INVITE_REMINDER,
})

export const getInviteReminderActionSuccess = (payload) => ({
    type: GET_INVITE_REMINDER_SUCCESS,
    payload
})

export const postAppointmentCancelAction = (body) => ({
    type: POST_APPOINTMENT_CANCEL,
    body
})

export const postAppointmentConfirmAction = (body) => ({
    type: POST_APPOINTMENT_CONFIRM,
    body
})

export const postAppointmentConfirmActionSuccess = (payload) => ({
    type: POST_APPOINTMENT_CONFIRM_SUCCESS,
    payload
})

export const resetScreeningStateAction = () => ({
    type: RESET_SCREENING_STATE,
})